var render = function () {
  var _vm$application$appli, _vm$application$appli2, _vm$application$appli3, _vm$application$appli4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: !_vm.dataLoaded,
      expression: "!dataLoaded"
    }]
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTitle', {
    attrs: {
      "title": "Просмотр заявления"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-space-between pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'applications'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-chevron-left")]), _vm._v(" Назад ")], 1), _c('div', [_vm.checkRoles ? [_c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "loading": _vm.btnLoading,
      "disabled": !!_vm.application.curator,
      "color": "success"
    },
    on: {
      "click": _vm.appointCurator
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-check-circle-outline")]), _vm._v(" Взять в обработку ")], 1), _c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "disabled": !_vm.application.curator || ((_vm$application$appli = _vm.application.applicationStatus) === null || _vm$application$appli === void 0 ? void 0 : _vm$application$appli.id) !== 2,
      "rounded": "",
      "color": "success"
    },
    on: {
      "click": function click($event) {
        _vm.typeDialog = 'approveApp';
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-check-circle-outline")]), _vm._v(" Принять ")], 1), _c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "disabled": !_vm.application.curator || ((_vm$application$appli2 = _vm.application.applicationStatus) === null || _vm$application$appli2 === void 0 ? void 0 : _vm$application$appli2.id) !== 2,
      "color": "warning"
    },
    on: {
      "click": function click($event) {
        _vm.typeDialog = 'modificationApp';
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-alert-circle-outline")]), _vm._v(" Доработка ")], 1), _c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "disabled": !_vm.application.curator || ![2, 4].includes((_vm$application$appli3 = _vm.application.applicationStatus) === null || _vm$application$appli3 === void 0 ? void 0 : _vm$application$appli3.id),
      "color": "red"
    },
    on: {
      "click": function click($event) {
        _vm.typeDialog = 'rejectApp';
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v(" Отклонить ")], 1)] : [_c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "success",
      "disabled": ![1, 3].includes((_vm$application$appli4 = _vm.application.applicationStatus) === null || _vm$application$appli4 === void 0 ? void 0 : _vm$application$appli4.id)
    },
    on: {
      "click": function click($event) {
        _vm.sendDialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-check-circle-outline")]), _vm._v(" Отправить заявление ")], 1)], _c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "success"
    },
    on: {
      "click": function click($event) {
        _vm.typeDialog = 'checkMsg';
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-email-outline")]), _vm._v(" Сообщения к заявлению ")], 1)], 2)], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('PersonalDataCard', {
    staticClass: "mb-3",
    attrs: {
      "personal-data": _vm.application.personalData
    }
  })], 1), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('DocumentPreviewCard', {
    attrs: {
      "values": _vm.selectedItem,
      "trigerShowPrint": _vm.triggerShowPrint
    }
  }), _c('ApplicationDataCard', {
    staticClass: "my-3",
    attrs: {
      "application": _vm.application
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('DocumentsCard', {
    attrs: {
      "application": _vm.application
    },
    on: {
      "selectItem": _vm.previewDocument
    }
  })], 1), _c('UniversalConfirmDialog', {
    attrs: {
      "type": _vm.typeDialog,
      "messages": _vm.application.messages,
      "loading": _vm.btnLoading
    },
    on: {
      "confirm": _vm.confirm,
      "closeDialog": _vm.closeDialog
    }
  }), _c('SendDialog', {
    attrs: {
      "dialog": _vm.sendDialog,
      "loading": _vm.sendLoading,
      "print-loading": _vm.printLoading
    },
    on: {
      "get-print": _vm.getPrint,
      "confirm": _vm.send,
      "closeDialog": _vm.closeDialog
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }